import {inject, injectable} from 'inversify';

import type {FileModel} from '../../domain/File/File.model';

import {logger} from '../../../utils/logger';
import {ReadFileQuery} from '../../ports/File/ReadFile/ReadFile.query';

@injectable()
export class ReadFileUseCase {
  constructor(@inject(ReadFileQuery) private readonly query: ReadFileQuery) {}

  async exec(props: ReadFileUseCase.Props): Promise<FileModel> {
    try {
      return this.query.exec(props);
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace ReadFileUseCase {
  export type Props = ReadFileQuery.Props;
}
